import type { SubjectEntry } from '../types/course';

export const subjects: SubjectEntry[] = [
  {
    id: 'primary',
    subject: '小学',
    summary: '生活情境、数量关系与一步一步的解题练习',
    status: 'published',
    modules: [
      { id: 'grade-3-word-problems', title: '三年级应用题专项练习', summary: '读题、找关系、列式、验算，四则运算、单位换算、周长面积与图表应用由基础到综合。', status: 'published', load: () => import('./primary/grade-3-word-problems') },
      { id: 'grade-4-math-question-types', title: '四年级数学：参考题型专项练习', summary: '算式、表格、线段图、周长与面积，按参考题型练读关系和列式。', status: 'published', load: () => import('./primary/grade-4-math-question-types') },
      { id: 'grade-3-english', title: '三年级英语：食物·文具·餐具·物品词汇', summary: 'PEP 2024 词汇专题：食物与健康、文具、餐具、物品四类单词认读与词义练习。', status: 'published', load: () => import('./primary/grade-3-english') },
      { id: 'grade-3-english-ppt1', title: 'PPT1：三年级英语下册 Unit 1·2·6 词汇', summary: 'PEP 三下 Unit 1、2、6：黑体重点词理解运用，白体词轻量认读。', status: 'published', load: () => import('./primary/grade-3-english-ppt1') },
      { id: 'grade-3-english-ppt2', title: 'PPT2：三年级英语上册 Unit 1—6 词汇', summary: 'PEP 三上 Unit 1—6：黑体重点词与重要白体词，多题型轮换巩固。', status: 'published', load: () => import('./primary/grade-3-english-ppt2') },
      { id: 'grade-3-english-practice-types', title: '三年级英语：生活情境五类题型', summary: '阅读理解、根据中文选词、情景交际、句图判断、看图填句，按方法与难度分层练习。', status: 'published', load: () => import('./primary/grade-3-english-practice-types') },
      { id: 'grade-3-english-review', title: '三年级英语：生活情境五类题型总复习', summary: '五类题型综合回看；每类两道以上全新自编题，换场景、换词汇、换答案结构。', status: 'published', load: () => import('./primary/grade-3-english-review') },
    ],
  },
  {
    id: 'maths',
    subject: '数学',
    summary: '概念、公式、图像、方法与分层练习',
    status: 'published',
    modules: [
      { id: 'small-question-types', title: '选择填空小题型', summary: '集合、基本不等式、复数、平面向量，四类基础题集中扫盲。', status: 'published', href: '/maths/small-question-types/' },
      { id: 'function', title: '函数性质', summary: '定义域、奇偶性、单调性、最值与周期性。', status: 'published', href: '/maths/function/' },
      { id: 'triangle-trig', title: '解三角形与三角函数', summary: '三角函数基础、正弦定理与余弦定理。', status: 'published', href: '/maths/triangle-trig/' },
      { id: 'solid-geometry', title: '立体几何', summary: '空间关系证明、线面角与距离计算。', status: 'published', href: '/maths/solid-geometry/' },
      { id: 'derivative', title: '导数', summary: '切线问题，以及用导数判断增减区间。', status: 'published', href: '/maths/derivative/' },
      { id: 'statistics-probability', title: '统计与概率', summary: '统计图表、独立性检验与概率模型。', status: 'published', href: '/maths/statistics-probability/' },
      { id: 'analytic-geometry', title: '解析几何', summary: '直线、圆与圆锥曲线的坐标方法。', status: 'published', href: '/maths/analytic-geometry/' },
      { id: 'all-chapters-review', title: '数学七章总复习（含数列）', summary: '约166分钟：重要公式、首选方法、代表例题与七章加数列检查。', status: 'published', load: () => import('./maths/all-chapters-review') },
      { id: 'targeted-practice-2', title: '三专题专项练习', summary: '导数、三角函数、解三角形与裂项相消：7道选择、7道填空、4道解答，建议100分钟。', status: 'published', load: () => import('./maths/targeted-practice-2') },
      { id: 'comprehensive-test', title: '全章节综合测试', summary: '168分钟、183分：7道单选、6道多选、7道填空、5道解答，覆盖全部已学数学章节。', status: 'published', load: () => import('./maths/comprehensive-test') },
      { id: 'big-question-drill', title: '大题考点刷题', summary: '10道大题、31个小问：数列、立体几何、概率统计、函数、导数、三角与解三角形。', status: 'published', load: () => import('./maths/big-question-drill') },
    ],
  },
  {
    id: 'english',
    subject: '英语',
    summary: '面向基础薄弱考生，分别训练应用文与读后续写',
    status: 'published',
    modules: [
      { id: 'practical-writing', title: '应用文写作', summary: '功能句、要点组织、结尾表达与应用文真题范文分析。', status: 'published', load: () => import('./english/practical-writing') },
      { id: 'continuation-writing', title: '读后续写', summary: '动作、情绪、对话与结果句型，以及续写真题范文分析。', status: 'published', load: () => import('./english/continuation-writing') },
    ],
  },
];

export const subjectPlaceholders: SubjectEntry[] = [
  { id: 'physics', subject: '物理', summary: '模型、受力、过程、图像与实验', status: 'placeholder', modules: [] },
  { id: 'chemistry', subject: '化学', summary: '反应、微粒、实验、结构与定量关系', status: 'placeholder', modules: [] },
];
